import withDraft from '@/utils/draftHelper';
import { removeItemByCode } from '@/utils/resultsHelper';
import { closeDatasetConditionsState, mapItemsToDatasetConditions } from './state';
import actions from '../../constants';

const destroyDataset = withDraft((draft, action) => {
  mapItemsToDatasetConditions(draft, action).parents.forEach(({ parent, category }) => {
    draft.datasetConditions[category].results = (
      removeItemByCode(draft.datasetConditions[category].results, parent)
    );
  });
});

export default {
  [actions.DESTROY_DATASET]: destroyDataset,
  [actions.FINISH_DATASET_WIZARD]: closeDatasetConditionsState,
};
